import { render, staticRenderFns } from "./News_add.vue?vue&type=template&id=9b9bf646&scoped=true&"
import script from "./News_add.vue?vue&type=script&lang=js&"
export * from "./News_add.vue?vue&type=script&lang=js&"
import style0 from "./News_add.vue?vue&type=style&index=0&id=9b9bf646&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9bf646",
  null
  
)

export default component.exports